import {
  ListInputItemOptions,
  ListInputItemOptionsWithSearch,
  SiftScreenEnum,
} from '../filter/model';
import {
  addListInputItems,
  addListInputItemsWithSearch,
  getAppliedFilters,
  updateSiftByScreen,
  FILTER_FEATURE_KEY,
} from '../filter/slice';
import { Api } from '../api/root-api';
import {
  AnalyticsQueryRequest,
  AnalyticsQueryResponse,
  DashboardPaymentsResponse,
  DashboardPaymentsRequest,
  AnalyticsRow,
  OtifAbsoluteOrdersDetailResponse,
  OtifDetailsRequest,
  OtifReceviedOrdersDetailResponse,
  OtifOrderFulfilmentDetailResponse,
  DailyOrdersReportRequest,
  DailyInvoicesReportRequest,
  DailyPaymentsReportRequest,
  DailyOrdersReportResponse,
  DailyPaymentsReportResponse,
  DailyInvoicesReportResponse,
  CustomersByOrderValueResponse,
  CustomersByOrderValueRequest,
  ProductsByQuantitySoldRequest,
  ProductsByQuantitySoldResponse,
  ReceivedOrdersReportRequest,
  RevenueReportRequest,
  RevenueReportResponse,
  ReceivedOrdersReportResponse,
  SalesLeaderboardRequest,
  SalesLeaderBoardResponse,
  RecentOrdersReportRequest,
  RecentOrdersReportResponse,
  RecentInvoicesReportRequest,
  RecentPaymentsReportRequest,
  RecentInvoicesReportResponse,
  RecentPaymentsReportResponse,
  ZoAiReportRequest,
  ZoAiReportResponse,
  CustomerCfaReportRequest,
  CustomerCfaReportResponse,
  ReportDownloadRequest,
  LedgerSummaryReportsRequest,
  LedgerSummaryReportsResponse,
  OrderSummaryReportDownloadReq,
  OrderDetailsReportResponse,
  OrderDetailsReportRequest,
  SalesLeaderboardReportResponse,
  SalesLeaderboardReportRequest,
  SalesLeaderboardReportDownloadRequest,
  InvoiceReportRequest,
  InvoiceReportResponse,
  CustomerReportDownloadRequest,
  ProductReportDownloadRequest,
  ProductPerformanceReportFilterRequest,
  salesTeamCheckinReportResponse,
  salesTeamCheckinReportRequest,
  PaymentsReportResponse,
  PaymentsReportRequest,
  ProductPerformanceReportFilterResponse,
  CustomerPerformanceReportFilterRequest,
  CustomerPerformanceReportFilterResponse,
  InviceReportFilterResponse,
  InviceReportFilterRequest,
  SalesTeamCheckinsReportFilterResponse,
  SalesTeamCheckinsReportFilterRequest,
  PaymentReportFilterResponse,
  PaymentReportFilterRequest,
  SecondaryInvoiceReportRequest,
  SecondaryInvoiceReportResponse,
  SecondaryInvoiceReportDownloadRequest,
  SecondaryInvoiceReportFilterRequest,
  SecondaryInvoiceReportFilterResponse,
  SupplyTrackerReportFilterResponse,
  SupplyTrackerReportFilterRequest,
  OrderDetailsReportFilterResponse,
  OrderDetailsReportFilterRequest,
  invoicesReportDownloadRequest,
  PaymentsReportDownloadRequest,
  SalesTeamCheckinReportDownloadRequest,
  SupplyTrackerReportDownloadRequest,
  BusinessSummaryReportResponse,
  BusinessSummaryReportRequest,
  UserKpis,
  KpiListRequest,
  ModifyKpisResponse,
  ModifyKpisRequest,
  KpiDetailsResponse,
  KpiDetailsRequest,
  SegmentAnalysisRequest,
  SegmentAnalysisResponse,
  DashboardFilterResponse,
  DashboardFilterRequest,
  UpdateDashboardFilterRequest,
  AppliedDashboardFiltersResponse,
  AppliedDashboardFiltersRequest,
  cfaCustomerWiseProductReportRequest,
  cfaCustomerWiseProductReportResponse,
  cfaCustomerWiseProductReportFilterResponse,
  cfaCustomerWiseProductReportFilterRequest,
  CampaignCustomersReportResponse,
  CampaignCustomersReportRequest,
  salesmenReportDownloadRequest,
  ListDynamicSegmentsResponse,
  ListDynamicSegmentsRequest,
  GetDynamicSegmentsDetailsRequest,
  GetDynamicSegmentsDetailsResponse,
  DownloadDynamicSegmentsDetailsRequest,
  WeeklySalesReportResponse,
  WeeklySalesReportRequest,
  MonthlySalesReportResponse,
  MonthlySalesReportRequest,
  salesManReportRequest,
  LedgerCustomerResponse,
  LedgerCustomerRequest,
  GetAnalyticsConfigRequest,
  GetAnalyticsConfigResponse,
  SaveAnalyticsConfigRequest,
  SaveAnalyticsConfigResponse,
  AnalyticsDownloadRequest,
  ProductViewRequest,
  ProductViewResponse,
  ProductViewFilterRequest,
  ProductViewFilterResponse,
  PaymentViewFilterRequest,
  PaymentViewFilterResponse,
  ProductDetailRequest,
  ProductDetailResponse,
  DashboardCustomerPaymentsRequest,
  DashboardCustomerPaymentsResponse,
  DashboardPaymentInvoiceRequest,
  DashboardPaymentInvoiceResponse,
  AnalyticsMetadataRequest,
  AnalyticsMetadataResponse,
  SalesAnalyticsQueryRequest,
  CustomerPerformanceReportRequest,
  CustomerPerformanceReportResponse,
  PerformanceReportDownloadRequest,
  SalesTeamMemberReportRequest,
  SalesTeamMemberReportResponse,
  OrderReportResponse,
  AnalyticsRequest,
  AnalyticsFiltersRequest,
  AnalyticsFiltersResponse,
  PaymentReportRequest,
  PaymentReportResponse,
} from './model';
import {
  mapDataToInputItems,
  mapDataToInputItemsFromAppliedFilter,
  mapStringDataToInputItemsFromAppliedFilter,
} from '../filter/helpers';
import { getStatusFilters } from '../filter/helpers/status-filters';
import { InvoiceStatusNames } from '../utils/helpers/enum';
import { RootState } from '../root/root-types';
import { setReportFilterApiResponse } from './slice';

const normalizeReportFilterApiResponse = (responseData: any) => {
  if (
    responseData &&
    typeof responseData === 'object' &&
    'data' in responseData &&
    Object.keys(responseData).length === 1
  ) {
    return (responseData as { data?: Record<string, any> }).data ?? {};
  }
  return responseData ?? {};
};

const cacheReportFilterResponseByScreen = (
  dispatch: any,
  filterScreen: SiftScreenEnum | undefined,
  responseData: any
) => {
  if (!filterScreen) return;
  dispatch(
    setReportFilterApiResponse({
      screen: filterScreen,
      response: normalizeReportFilterApiResponse(responseData),
    })
  );
};

export const reportsApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    generateOtifAbsoluteOrdersReport: builder.mutation<
      OtifAbsoluteOrdersDetailResponse,
      OtifDetailsRequest
    >({
      query(arg) {
        const { workspaceId, ...otherParams } = arg;
        return {
          url: `dna-report/on-time-in-full/absolute-orders/${workspaceId}`,
          method: 'POST',
          body: otherParams,
        };
      },
    }),
    generateOtifRecivedOrdersReport: builder.mutation<
      OtifReceviedOrdersDetailResponse,
      OtifDetailsRequest
    >({
      query(arg) {
        const { workspaceId, ...otherParams } = arg;
        return {
          url: `on-time-in-full/received-orders/${workspaceId}`,
          method: 'POST',
          body: otherParams,
        };
      },
    }),
    generateOtifOrderFulfilmentReport: builder.mutation<
      OtifOrderFulfilmentDetailResponse,
      OtifDetailsRequest
    >({
      query(arg) {
        const { workspaceId, ...otherParams } = arg;
        return {
          url: `on-time-in-full/order-fulfilment/${workspaceId}`,
          method: 'POST',
          body: otherParams,
        };
      },
    }),

    revenueReport: builder.mutation<
      RevenueReportResponse,
      RevenueReportRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/revenue-report',
          method: 'POST',
          body: arg,
        };
      },
    }),
    salesLeaderBoard: builder.mutation<
      SalesLeaderBoardResponse,
      SalesLeaderboardRequest
    >({
      query: (arg) => ({
        url: 'hub/reports/api/v2/sales-order-report/leader-board',
        method: 'POST',
        body: arg,
      }),
    }),
    receivedOrdersReport: builder.mutation<
      { data: ReceivedOrdersReportResponse[]; updatedAt: string },
      ReceivedOrdersReportRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/received-orders',
          method: 'POST',
          body: arg,
        };
      },
      transformResponse: (response: {
        data: ReceivedOrdersReportResponse[];
        updatedAt: string;
      }) => {
        return {
          data: response?.data,
          updatedAt: response?.updatedAt,
        };
      },
    }),
    dailyOrdersReport: builder.mutation<
      DailyOrdersReportResponse,
      DailyOrdersReportRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/orders-report',
          method: 'POST',
          body: arg,
        };
      },
    }),
    dailyPaymentsReport: builder.mutation<
      DailyPaymentsReportResponse,
      DailyPaymentsReportRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/daily-payments-report',
          method: 'POST',
          body: arg,
        };
      },
    }),
    dailyInvoicesReport: builder.mutation<
      DailyInvoicesReportResponse,
      DailyInvoicesReportRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/daily-invoice-report',
          method: 'POST',
          body: arg,
        };
      },
    }),
    topCustomersByOrderValue: builder.mutation<
      CustomersByOrderValueResponse,
      CustomersByOrderValueRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/customer-performance-report',
          method: 'POST',
          body: arg,
        };
      },
    }),
    bottomCustomersByOrderValue: builder.mutation<
      CustomersByOrderValueResponse,
      CustomersByOrderValueRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/customer-performance-report',
          method: 'POST',
          body: arg,
        };
      },
    }),
    topProductsByQuantitySold: builder.mutation<
      ProductsByQuantitySoldResponse,
      ProductsByQuantitySoldRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/product-performance-report',
          method: 'POST',
          body: arg,
        };
      },
    }),
    bottomProductsByQuantitySold: builder.mutation<
      ProductsByQuantitySoldResponse,
      ProductsByQuantitySoldRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/product-performance-report',
          method: 'POST',
          body: arg,
        };
      },
    }),
    zoaiReport: builder.mutation<ZoAiReportResponse, ZoAiReportRequest>({
      query(args) {
        return {
          url: '/hub/reports/api/v2/zoai-reports',
          method: 'POST',
          body: args,
        };
      },
    }),
    recentOrdersReport: builder.query<
      RecentOrdersReportResponse[],
      RecentOrdersReportRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/recent-orders`,
          method: 'GET',
          params: arg,
        };
      },
    }),
    recentInvoiceReport: builder.query<
      RecentInvoicesReportResponse[],
      RecentInvoicesReportRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/recent-invoices`,
          method: 'GET',
          params: arg,
        };
      },
    }),
    recentPaymentReport: builder.query<
      RecentPaymentsReportResponse[],
      RecentPaymentsReportRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/recent-payments`,
          method: 'GET',
          params: arg,
        };
      },
    }),

    getPaymentReportApi: builder.mutation<
      PaymentsReportResponse,
      PaymentsReportRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/recent-payments`,
          method: 'POST',
          body: arg,
        };
      },
    }),

    getSecondaryInvoiceReportApi: builder.mutation<
      SecondaryInvoiceReportResponse,
      SecondaryInvoiceReportRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v1/secondary-invoice-report`,
          method: 'POST',
          body: arg,
        };
      },
    }),

    secondaryInvoiceReportFilter: builder.mutation<
      SecondaryInvoiceReportFilterResponse,
      SecondaryInvoiceReportFilterRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v1/secondary-invoice-report/filter',
          method: 'POST',
          body: arg?.body,
        };
      },
      onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        if (request?.filterScreen) {
          queryFulfilled?.then((response) => {
            cacheReportFilterResponseByScreen(
              dispatch,
              request.filterScreen,
              response?.data
            );
            const state = getState() as RootState;
            const appliedByScreen =
              state?.filtersData?.sift?.[SiftScreenEnum.APPLIED_FILTERS]?.[
                request.filterScreen
              ] || {};
            const raw = response?.data as
              | SecondaryInvoiceReportFilterResponse
              | { data?: SecondaryInvoiceReportFilterResponse };
            const data =
              raw &&
              (raw as any).buyers === undefined &&
              (raw as any).distributors === undefined &&
              (raw as any).data
                ? (raw as { data: SecondaryInvoiceReportFilterResponse }).data
                : (raw as SecondaryInvoiceReportFilterResponse);

            const setSelectedFromApplied =
              (key: ListInputItemOptions) =>
              (item: { id: string; value: string; selected?: boolean }) => ({
                ...item,
                selected:
                  (appliedByScreen[key] as string[] | undefined)?.includes(
                    item.id
                  ) ?? false,
              });

            const statusOptions = [
              { id: 'PENDING', value: 'Pending', selected: false },
              { id: 'APPROVED', value: 'Approved', selected: false },
              {
                id: 'PROCESSCOMPLETED',
                value: 'Process Completed',
                selected: false,
              },
              { id: 'REJECTED', value: 'Rejected', selected: false },
            ];
            const statusInputItems = statusOptions
              .map(
                setSelectedFromApplied(
                  ListInputItemOptions.turnoverInvoiceStatus
                )
              )
              ?.filter((x: any) => x.value);

            const validationOptions = [
              { id: 'Identified', value: 'Identified', selected: false },
              {
                id: 'Not Identified',
                value: 'Not Identified',
                selected: false,
              },
            ];
            const validationInputItems = validationOptions
              .map(
                setSelectedFromApplied(
                  ListInputItemOptions.turnoverInvoiceValidationStatus
                )
              )
              ?.filter((x: any) => x.value);

            const buyerInputItems = (data?.buyers ?? [])
              .map((b: { buyerName: string; customerId: string }) => ({
                id: b.customerId,
                value: b.buyerName,
                selected:
                  (
                    appliedByScreen[
                      ListInputItemOptions.turnoverInvoiceBuyer
                    ] as string[] | undefined
                  )?.includes(b.customerId) ?? false,
              }))
              .filter((x) => x.id && x.value);

            const distributorInputItems = (data?.distributors ?? [])
              .map((d: { distributorName: string; cfaId: string }) => ({
                id: d.distributorName,
                value: d.distributorName,
                selected:
                  (
                    appliedByScreen[
                      ListInputItemOptions.turnoverInvoiceSeller
                    ] as string[] | undefined
                  )?.includes(d.cfaId) ?? false,
              }))
              .filter((x) => x.id && x.value);

            const lineItemStatusOptions = [
              {
                id: 'Unmapped',
                value: 'Unmapped',
                selected: false,
                eitherOr: true,
              },
              {
                id: 'Mapped',
                value: 'Mapped',
                selected: false,
                eitherOr: true,
              },
            ];
            // Line item status: single selection only (eitherOr), stored as string
            const appliedLineItemStatus = appliedByScreen[
              ListInputItemOptions.turnoverInvoiceLineItemStatus
            ] as string | string[] | undefined;
            const appliedLineItemStatusStr =
              typeof appliedLineItemStatus === 'string'
                ? appliedLineItemStatus
                : Array.isArray(appliedLineItemStatus)
                  ? appliedLineItemStatus[0]
                  : undefined;
            const lineItemStatusInputItems = lineItemStatusOptions.map(
              (item) => ({
                ...item,
                selected: appliedLineItemStatusStr === item.id,
              })
            );

            dispatch(
              updateSiftByScreen({
                screen: request.filterScreen,
                filters: {
                  [ListInputItemOptions.turnoverInvoiceStatus]:
                    statusInputItems,
                  [ListInputItemOptions.turnoverInvoiceValidationStatus]:
                    validationInputItems,
                  [ListInputItemOptions.turnoverInvoiceBuyer]: buyerInputItems,
                  [ListInputItemOptions.turnoverInvoiceSeller]:
                    distributorInputItems,
                  [ListInputItemOptions.turnoverInvoiceLineItemStatus]:
                    lineItemStatusInputItems,
                },
              })
            );
          });
        }
      },
    }),

    secondaryInvoiceReportDownload: builder.mutation<
      Blob,
      SecondaryInvoiceReportDownloadRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v1/secondary-invoice-report/download',
          method: 'POST',
          body: arg,
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    downloadCfaReports: builder.mutation<string, ReportDownloadRequest>({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/customer-or-cfa-product-wise-order-report/download`,
          method: 'POST',
          body: arg,
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    downloadSalesmenReport: builder.mutation<
      string,
      salesmenReportDownloadRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v1/salesmen-detail-report/download`,
          method: 'POST',
          body: arg,
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    cfaCustomerWiseProductReport: builder.mutation<
      cfaCustomerWiseProductReportResponse,
      cfaCustomerWiseProductReportRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/customer-or-cfa-product-wise-order-report`,
          method: 'POST',
          body: arg,
        };
      },
    }),

    cfaCustomerWiseProductReportFilter: builder.mutation<
      cfaCustomerWiseProductReportFilterResponse,
      cfaCustomerWiseProductReportFilterRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/customer-or-cfa-product-wise-order-report/filter`,
          method: 'POST',
          body: arg.body,
        };
      },
      onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        if (request?.filterScreen as SiftScreenEnum) {
          queryFulfilled?.then((response) => {
            cacheReportFilterResponseByScreen(
              dispatch,
              request.filterScreen,
              response?.data
            );
            const appliedFilters = getAppliedFilters(getState() as RootState);
            const fulfillmentsInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.cfas,
              'cfaId',
              'cfaName',
              ''
            )?.filter((x: any) => x.value);
            dispatch(
              addListInputItems({
                inputItems: fulfillmentsInputItems,
                key: ListInputItemOptions.cfa,
              })
            );
            dispatch(
              addListInputItemsWithSearch({
                inputItems: [],
                key: ListInputItemOptionsWithSearch.customers,
              })
            );
            dispatch(
              updateSiftByScreen({
                screen: request?.filterScreen,
                filters: {
                  customers: [],
                  cfa: fulfillmentsInputItems,
                },
              })
            );
          });
        }
      },
    }),

    customerCfaReport: builder.mutation<
      CustomerCfaReportResponse,
      CustomerCfaReportRequest
    >({
      query: (arg) => {
        const { dispatchFilters, ...otherFilters } = arg;
        return {
          url: '/hub/reports/api/v2/cfa-product-wise-order-grouping-report',
          method: 'POST',
          body: otherFilters,
        };
      },
      async onQueryStarted(request, { dispatch, queryFulfilled }) {
        queryFulfilled.then((response) => {
          if (request.dispatchFilters) {
            const tags = [
              {
                id: '12am to 1pm',
                name: 'Morning',
              },
              {
                id: '1pm to 12am',
                name: 'Evening',
              },
            ];
            const tagsItems = mapDataToInputItems(tags, 'id', 'name')?.filter(
              (x: any) => x.value
            );

            const cfas = response?.data?.fulfillments
              ?.map((x) => ({
                id: x?.cfaIds,
                name: x?.cfaName,
              }))
              ?.filter(
                (obj, index, self) =>
                  index === self.findIndex((o) => o.id === obj.id)
              );

            const customers = response?.data?.customers
              ?.map((x) => ({
                id: x?.customerId,
                name: x?.customerFirmName,
              }))
              ?.filter(
                (obj, index, self) =>
                  index === self.findIndex((o) => o.id === obj.id)
              );

            const cfaItems = mapDataToInputItems(cfas, 'id', 'name')?.filter(
              (x: any) => x.value
            );

            const customerItems = mapDataToInputItems(
              customers,
              'id',
              'name'
            )?.filter((x: any) => x.value);

            dispatch(
              addListInputItems({
                inputItems: cfaItems,
                key: ListInputItemOptions.cfaReports,
              })
            );
            dispatch(
              addListInputItems({
                inputItems: customerItems,
                key: ListInputItemOptions.cfaCustomers,
              })
            );

            dispatch(
              addListInputItems({
                inputItems: tagsItems,
                key: ListInputItemOptions.tags,
              })
            );
          }
        });
      },
    }),
    ledgerSummaryReport: builder.mutation<
      LedgerSummaryReportsResponse,
      LedgerSummaryReportsRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/ledger-summary-report`,
          method: 'POST',
          body: arg,
        };
      },
    }),

    orderDetailsReport: builder.mutation<
      OrderDetailsReportResponse,
      OrderDetailsReportRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/order-details-report`,
          method: 'POST',
          body: arg,
        };
      },
    }),
    orderDetailsReportFilter: builder.mutation<
      OrderDetailsReportFilterResponse,
      OrderDetailsReportFilterRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/order-details-report/filter`,
          method: 'POST',
          body: arg.body,
        };
      },

      onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        if (request?.filterScreen as SiftScreenEnum) {
          queryFulfilled?.then((response) => {
            cacheReportFilterResponseByScreen(
              dispatch,
              request.filterScreen,
              response?.data
            );
            const appliedFilters = getAppliedFilters(getState() as RootState);
            const fulfillmentsInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.fulfillments,
              'cfaId',
              'cfaName',
              ''
            )?.filter((x: any) => x.value);

            const salesManInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.salesmen,
              'salesmenId',
              'salesTeamMemberName',
              ''
            )?.filter((x: any) => x.value);
            const statusInputItems = getStatusFilters(
              response?.data?.statuses ?? [],
              false
            )?.filter((x: any) => x.value);

            const tags = [
              {
                id: '12am to 1pm',
                name: 'Morning',
              },
              {
                id: '1pm to 12am',
                name: 'Evening',
              },
            ];
            const tagsItems = mapDataToInputItems(tags, 'id', 'name')?.filter(
              (x: any) => x.value
            );

            const state = getState() as RootState;
            const appliedCustomerIds: string[] =
              (state as any)[FILTER_FEATURE_KEY]?.sift?.[
                SiftScreenEnum.APPLIED_FILTERS
              ]?.[request?.filterScreen]?.customers ?? [];
            const customerInputItems = (response?.data?.customers ?? []).map(
              (c: any) => {
                const customerId = String(c?.inviteId ?? '');
                return {
                  id: customerId,
                  value: c?.customerName || '',
                  selected: appliedCustomerIds.includes(customerId),
                };
              }
            );

            dispatch(
              updateSiftByScreen({
                screen: request?.filterScreen,
                filters: {
                  customers: customerInputItems,
                  cfa: fulfillmentsInputItems,
                  salesmen: salesManInputItems,
                  statuses: statusInputItems,
                },
              })
            );
          });
        }
      },
    }),

    orderSummaryReportDownload: builder.mutation<
      any,
      OrderSummaryReportDownloadReq
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/order-details-report/download',
          method: 'POST',
          body: arg.body,
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    salesLeaderboardReport: builder.mutation<
      SalesLeaderboardReportResponse,
      SalesLeaderboardReportRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/sales-order-report/leader-board`,
          method: 'POST',
          body: arg,
        };
      },
    }),
    salesLeaderClockinsReport: builder.mutation<any, any>({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/sales-order-report/clockins`,
          method: 'POST',
          body: arg,
        };
      },
    }),

    salesLeaderboardReportDownload: builder.mutation<
      any,
      SalesLeaderboardReportDownloadRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/sales-order-report/leader-board/download',
          method: 'POST',
          body: arg,
          responseHandler: (response) => response.blob(),
        };
      },
    }),
    salesLeaderClockinDownload: builder.mutation<
      any,
      SalesLeaderboardReportDownloadRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/sales-order-report/clockins/download',
          method: 'POST',
          body: arg,
          responseHandler: (response) => response.blob(),
        };
      },
    }),
    customerPerformanceReportDownload: builder.mutation<
      any,
      CustomerReportDownloadRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/customer-performance-report/download',
          method: 'POST',
          body: arg,
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    paymentsReportDownload: builder.mutation<
      any,
      PaymentsReportDownloadRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/recent-payments/download',
          method: 'POST',
          body: arg,
          responseHandler: (response) => response.blob(),
        };
      },
    }),
    invoicesReportDownload: builder.mutation<
      any,
      invoicesReportDownloadRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/recent-invoices/download',
          method: 'POST',
          body: arg,
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    productPerformanceReportDownload: builder.mutation<
      any,
      ProductReportDownloadRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/product-performance-report/download',
          method: 'POST',
          body: arg,
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    invoiceReport: builder.mutation<
      InvoiceReportResponse,
      InvoiceReportRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/recent-invoices',
          method: 'POST',
          body: arg,
        };
      },
    }),

    invoiceReportFilter: builder.mutation<
      InviceReportFilterResponse,
      InviceReportFilterRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/recent-invoices/filter',
          method: 'POST',
          body: arg.body,
        };
      },
      onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        if (request?.filterScreen as SiftScreenEnum) {
          queryFulfilled?.then((response) => {
            cacheReportFilterResponseByScreen(
              dispatch,
              request.filterScreen,
              response?.data
            );
            const appliedFilters = getAppliedFilters(getState() as RootState);
            const invoiceStatusData = response?.data?.invoiceStatus?.map(
              (x) => ({
                statusId: x,
                statusName:
                  InvoiceStatusNames[x as keyof typeof InvoiceStatusNames],
              })
            );
            const invoioceStatusInputItems =
              mapDataToInputItemsFromAppliedFilter(
                appliedFilters,
                invoiceStatusData,
                'statusId',
                'statusName',
                ListInputItemOptions.invoiceStatus
              )?.filter((x: any) => x.value);

            const orderNumberData = response?.data?.orderNumber?.map((x) => ({
              orderId: x,
              orderRefNumber: x,
            }));
            const orderNumberDataInputItems =
              mapDataToInputItemsFromAppliedFilter(
                appliedFilters,
                orderNumberData,
                'orderId',
                'orderRefNumber',
                ListInputItemOptions.orderNumber
              )?.filter((x: any) => x.value);

            const dueDateData = response?.data?.dueDate?.map((x) => ({
              dueDateId: x,
              dueDate: x,
            }));
            const dueDateDataInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              dueDateData,
              'dueDateId',
              'dueDate',
              ListInputItemOptions.dueDate
            )?.filter((x: any) => x.value);

            const dispatchDateData = response?.data?.dispatchDate?.map((x) => ({
              dispatchDateId: x,
              dispatchDate: x,
            }));
            const dispatchDateDataInputItems =
              mapDataToInputItemsFromAppliedFilter(
                appliedFilters,
                dispatchDateData,
                'dispatchDateId',
                'dispatchDate',
                ListInputItemOptions.dispatchDate
              )?.filter((x: any) => x.value);

            const customerData = response?.data?.customerName?.map((x) => ({
              customerId: x?.customerId,
              customerName: x?.customerName,
            }));
            const customerInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              customerData,
              'customerId',
              'customerName',
              ListInputItemOptions.customers
            )?.filter((x: any) => x.value);

            dispatch(
              updateSiftByScreen({
                screen: request?.filterScreen,
                filters: {
                  invoiceStatus: invoioceStatusInputItems,
                  refOrderNumber: orderNumberDataInputItems,
                  dueDate: dueDateDataInputItems,
                  dispatchDate: dispatchDateDataInputItems,
                  customers: [],
                },
              })
            );
          });
        }
      },
    }),
    salesTeamCheckinReport: builder.mutation<
      salesTeamCheckinReportResponse,
      salesTeamCheckinReportRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/salesmen-checkins-report',
          method: 'POST',
          body: arg,
        };
      },
    }),

    salesTeamCheckinDownload: builder.mutation<
      any,
      SalesTeamCheckinReportDownloadRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/salesmen-checkins-report/download',
          method: 'POST',
          body: arg,
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    salesTeamCheckinReportFilter: builder.mutation<
      SalesTeamCheckinsReportFilterResponse,
      SalesTeamCheckinsReportFilterRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/salesmen-checkins-report/filter',
          method: 'POST',
          body: arg.body,
        };
      },
      onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        if (request?.filterScreen as SiftScreenEnum) {
          const appliedFilters = getAppliedFilters(getState() as RootState);
          queryFulfilled?.then((response) => {
            cacheReportFilterResponseByScreen(
              dispatch,
              request.filterScreen,
              response?.data
            );
            const customerInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.customers,
              'customerId',
              'customerName',
              ListInputItemOptions.customers
            )?.filter((x: any) => x.value);

            const salesTeamMembers = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.salesTeamMembers,
              'salesTeamMemberId',
              'salesTeamMemberName',
              ListInputItemOptions.salesCfa
            )?.filter((x: any) => x.value);

            dispatch(
              updateSiftByScreen({
                screen: request?.filterScreen,
                filters: {
                  customer: customerInputItems ?? [],
                  salesTeamMembers: salesTeamMembers ?? [],
                },
              })
            );
          });
        }
      },
    }),

    productPerformanceReportFilter: builder.mutation<
      ProductPerformanceReportFilterResponse,
      ProductPerformanceReportFilterRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/product-performance-report/filter',
          method: 'POST',
          body: arg?.body,
        };
      },
      onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        if (request?.filterScreen as SiftScreenEnum) {
          queryFulfilled?.then((response) => {
            cacheReportFilterResponseByScreen(
              dispatch,
              request.filterScreen,
              response?.data
            );
            console.log('request?.filterScreen response: ', response?.data);
            const appliedFilters = getAppliedFilters(getState() as RootState);

            const categoriesInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.category,
              'categoryId',
              'category',
              ListInputItemOptions.categories
            )?.filter((x: any) => x.value);

            const divisionInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.division,
              'divisionId',
              'division',
              ListInputItemOptions.divisions
            )?.filter((x: any) => x.value);

            const productNamesInputItems = (
              response?.data?.productNames ?? []
            ).map((p) => ({
              id: p.productId,
              value: p.productname,
              selected: false,
            }));

            dispatch(
              updateSiftByScreen({
                screen: request?.filterScreen,
                filters: {
                  category: categoriesInputItems,
                  division: divisionInputItems,
                  customers: [],
                  productNames: productNamesInputItems,
                },
              })
            );
            // dispatch(
            //   addListInputItems({
            //     inputItems: categoriesInputItems,
            //     key: ListInputItemOptions.categories,
            //   })
            // );
            // dispatch(
            //   addListInputItems({
            //     inputItems: divisionInputItems,
            //     key: ListInputItemOptions.divisions,
            //   })
            // );
            // dispatch(
            //   addListInputItemsWithSearch({
            //     inputItems: [],
            //     key: ListInputItemOptionsWithSearch.customers,
            //   })
            // );
          });
        }
      },
    }),

    customerPerformanceReportFilter: builder.mutation<
      CustomerPerformanceReportFilterResponse,
      CustomerPerformanceReportFilterRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/customer-performance-report/filter',
          method: 'POST',
          body: arg?.body,
        };
      },
      onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        if (request?.filterScreen as SiftScreenEnum) {
          queryFulfilled?.then((response) => {
            cacheReportFilterResponseByScreen(
              dispatch,
              request.filterScreen,
              response?.data
            );
            console.log('request?.filterScreen response: ', response?.data);
            const appliedFilters = getAppliedFilters(getState() as RootState);

            const districtInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.district,
              'district',
              'district',
              ''
            )?.filter((x: any) => x.value);

            const stateInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.state,
              'state',
              'state',
              ''
            )?.filter((x: any) => x.value);

            const pincodeInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.pinCode,
              'inviteId',
              'inviteId',
              ''
            )?.filter((x: any) => x.value);

            dispatch(
              updateSiftByScreen({
                screen: request?.filterScreen,
                filters: {
                  district: districtInputItems,
                  state: stateInputItems,
                  pincode: pincodeInputItems,
                  customers: [],
                },
              })
            );
            // dispatch(
            //   addListInputItems({
            //     inputItems: districtInputItems,
            //     key: ListInputItemOptions.district,
            //   })
            // );
            // dispatch(
            //   addListInputItems({
            //     inputItems: stateInputItems,
            //     key: ListInputItemOptions.states,
            //   })
            // );
            // dispatch(
            //   addListInputItems({
            //     inputItems: pincodeInputItems,
            //     key: ListInputItemOptions.pinCode,
            //   })
            // );
            // dispatch(
            //   addListInputItemsWithSearch({
            //     inputItems: [],
            //     key: ListInputItemOptionsWithSearch.customers,
            //   })
            // );
          });
        }
      },
    }),

    recentPaymentsReportFilter: builder.mutation<
      PaymentReportFilterResponse,
      PaymentReportFilterRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/recent-payments/filter',
          method: 'POST',
          body: arg?.body,
        };
      },
      onQueryStarted(request, { dispatch, queryFulfilled }) {
        if (request?.filterScreen as SiftScreenEnum) {
          queryFulfilled?.then((response) => {
            cacheReportFilterResponseByScreen(
              dispatch,
              request.filterScreen,
              response?.data
            );
            // const customerInputItems = response?.data?.customer?.map((item) => {
            //   return {
            //     id: item?.customerId,
            //     value: item?.customerName,
            //     selected: false,
            //   };
            // });

            const paymentStatusInputItems = response?.data?.paymentStatus?.map(
              (val) => {
                return {
                  id: val,
                  value: val,
                  selected: false,
                };
              }
            );

            const orderNumberInputItems = response?.data?.orderNumber?.map(
              (val) => {
                return {
                  id: val,
                  value: val,
                  selected: false,
                };
              }
            );

            dispatch(
              updateSiftByScreen({
                screen: request?.filterScreen,
                filters: {
                  customers: [],
                  paymentStatus: paymentStatusInputItems,
                  // orderNumber: orderNumberInputItems,
                },
              })
            );
            // dispatch(
            //   addListInputItemsWithSearch({
            //     inputItems: [],
            //     key: ListInputItemOptionsWithSearch.customers,
            //   })
            // );
            // dispatch(
            //   addListInputItems({
            //     inputItems: paymentStatusInputItems,
            //     key: ListInputItemOptions.paymentStatus,
            //   })
            // );
          });
        }
      },
    }),

    supplyTrackerReportFilter: builder.mutation<
      SupplyTrackerReportFilterResponse,
      SupplyTrackerReportFilterRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/cfa-product-wise-order-grouping-report/filter',
          method: 'POST',
          body: arg?.body,
        };
      },
      onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        if (request?.filterScreen as SiftScreenEnum) {
          queryFulfilled?.then((response) => {
            cacheReportFilterResponseByScreen(
              dispatch,
              request.filterScreen,
              response?.data
            );
            const appliedFilters = getAppliedFilters(getState() as RootState);
            const fulfillmentsInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.fulfillments,
              'cfaId',
              'cfaName',
              ''
            )?.filter((x: any) => x.value);

            const tags = [
              {
                id: '12am to 1pm',
                name: 'Morning',
              },
              {
                id: '1pm to 12am',
                name: 'Evening',
              },
            ];
            const tagsItems = mapDataToInputItems(tags, 'id', 'name')?.filter(
              (x: any) => x.value
            );

            // dispatch(
            //   addListInputItems({
            //     inputItems: tagsItems,
            //     key: ListInputItemOptions.tags,
            //   })
            // );
            // dispatch(
            //   addListInputItems({
            //     inputItems: fulfillmentsInputItems,
            //     key: ListInputItemOptions.fulfillments,
            //   })
            // );
            // dispatch(
            //   addListInputItemsWithSearch({
            //     inputItems: [],
            //     key: ListInputItemOptionsWithSearch.customers,
            //   })
            // );
            dispatch(
              updateSiftByScreen({
                screen: request?.filterScreen,
                filters: {
                  fulfillments: fulfillmentsInputItems,
                  tags: tagsItems,
                  customers: [],
                },
              })
            );
          });
        }
      },
    }),

    supplyTrackerReportDownload: builder.mutation<
      any,
      SupplyTrackerReportDownloadRequest
    >({
      query(arg) {
        return {
          url: 'hub/reports/api/v2/cfa-product-wise-order-grouping-report/download',
          method: 'POST',
          params: arg?.params,
          body: arg?.body,
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    campaignCustomersReport: builder.mutation<
      CampaignCustomersReportResponse,
      CampaignCustomersReportRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/campaign',
          method: 'POST',
          body: arg,
        };
      },
    }),

    businessSummaryReport: builder.mutation<
      BusinessSummaryReportResponse,
      BusinessSummaryReportRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v2/dashboard/business-summary',
          method: 'POST',
          body: arg,
        };
      },
    }),

    getKpiList: builder.query<UserKpis[], KpiListRequest>({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/dashboard/kpi/users`,
          method: 'GET',
          params: arg,
        };
      },
    }),

    modifyKpis: builder.mutation<ModifyKpisResponse, ModifyKpisRequest>({
      query(arg) {
        const { body, ...otherParams } = arg;
        return {
          url: `/hub/reports/api/v2/dashboard/kpi/users`,
          method: 'POST',
          params: otherParams,
          body,
        };
      },
    }),

    getKpiDetails: builder.mutation<KpiDetailsResponse, KpiDetailsRequest>({
      query(arg) {
        const { body, ...otherParams } = arg;
        return {
          url: `/hub/reports/api/v2/dashboard/kpi/details`,
          method: 'POST',
          params: otherParams,
          body,
        };
      },
    }),
    getSegmentAnalysis: builder.mutation<
      SegmentAnalysisResponse[],
      SegmentAnalysisRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/dashboard/segment-analysis/details`,
          method: 'POST',
          params: { sellerWorkspaceId: arg.sellerWorkspaceId },
          body: arg,
        };
      },
    }),

    listDashboardFilters: builder.mutation<
      DashboardFilterResponse,
      DashboardFilterRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/dashboard/filter`,
          method: 'POST',
          body: arg,
        };
      },
    }),

    updateDashboardFilters: builder.mutation<
      string,
      UpdateDashboardFilterRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/dashboard/reports/filters`,
          method: 'POST',
          body: arg,
        };
      },
    }),
    getAppliedDashboardFilters: builder.query<
      AppliedDashboardFiltersResponse,
      AppliedDashboardFiltersRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v2/dashboard/filters`,
          method: 'GET',
          params: arg,
        };
      },
    }),
    listDynamicSegments: builder.mutation<
      ListDynamicSegmentsResponse,
      ListDynamicSegmentsRequest
    >({
      query(args) {
        return {
          url: `/hub/reports/api/v2/segment-membership`,
          method: 'POST',
          params: args.params,
          body: args.body,
        };
      },
    }),
    getDynamicSegmentsDetails: builder.mutation<
      GetDynamicSegmentsDetailsResponse,
      GetDynamicSegmentsDetailsRequest
    >({
      query(args) {
        return {
          url: `/hub/reports/api/v2/segment-membership/details`,
          method: 'POST',
          params: args.params,
          body: args.body,
        };
      },
    }),
    downloadDynamicSegmentsDetails: builder.mutation<
      string,
      DownloadDynamicSegmentsDetailsRequest
    >({
      query(args) {
        return {
          url: `hub/reports/api/v2/segment-membership/download`,
          method: 'POST',
          body: args,
          responseHandler: (response) => response.blob(),
        };
      },
    }),
    getWeeklySalesReport: builder.mutation<
      WeeklySalesReportResponse,
      WeeklySalesReportRequest
    >({
      query(args) {
        return {
          url: `hub/reports/api/v1/field-ops/weekly-sales-report`,
          method: 'POST',
          params: args.params,
          body: args.body,
        };
      },
    }),
    getMonthlySalesReport: builder.mutation<
      MonthlySalesReportResponse,
      MonthlySalesReportRequest
    >({
      query(args) {
        return {
          url: `hub/reports/api/v1/field-ops/monthly-sales-report`,
          method: 'POST',
          params: args.params,
          body: args.body,
        };
      },
    }),
    salesManReport: builder.mutation<any, salesManReportRequest>({
      query(args) {
        return {
          url: `/hub/reports/api/v1/salesmen-metrics-report`,
          method: 'POST',
          params: args?.params,
          body: args?.payload,
        };
      },
    }),
    ledgerCustomer: builder.mutation<
      LedgerCustomerResponse,
      LedgerCustomerRequest
    >({
      query(args) {
        return {
          url: `/hub/reports/api/v1/ledger`,
          method: 'POST',
          params: {
            sellerWorkspaceId: args?.sellerWorkspaceId,
          },
          body: args,
        };
      },
    }),

    dashboardPaymentsReport: builder.mutation<
      DashboardPaymentsResponse,
      DashboardPaymentsRequest
    >({
      query(args) {
        const { sellerWorkspaceId, ...body } = args;
        return {
          url: `/hub/reports/api/v1/analytics/paymentview`,
          method: 'POST',
          params: {
            sellerWorkspaceId,
          },
          body,
        };
      },
    }),

    dashboardCustomerPaymentsReport: builder.mutation<
      DashboardCustomerPaymentsResponse,
      DashboardCustomerPaymentsRequest
    >({
      query(args) {
        const { sellerWorkspaceId, ...body } = args;
        return {
          url: `/hub/reports/api/v1/analytics/paymentview/customer`,
          method: 'POST',
          params: {
            sellerWorkspaceId,
          },
          body,
        };
      },
    }),

    dashboardPaymentInvoice: builder.mutation<
      DashboardPaymentInvoiceResponse,
      DashboardPaymentInvoiceRequest
    >({
      query(args) {
        const { sellerWorkspaceId, ...body } = args;
        return {
          url: `/hub/reports/api/v1/analytics/paymentview/invoice`,
          method: 'POST',
          params: {
            sellerWorkspaceId,
          },
          body,
        };
      },
    }),

    runAnalyticsQuery: builder.mutation<
      AnalyticsQueryResponse,
      AnalyticsQueryRequest
    >({
      query(args) {
        const { sellerWorkspaceId, ...body } = args;
        return {
          url: `/hub/reports/api/v1/analytics/query`,
          method: 'POST',
          params: {
            sellerWorkspaceId,
          },
          body,
        };
      },
      transformResponse(raw: any): AnalyticsQueryResponse {
        const extractRows = (data: any): AnalyticsRow[] => {
          if (Array.isArray(data)) return data;
          for (const key of ['data', 'rows', 'result', 'records']) {
            const v = data?.[key];
            if (Array.isArray(v)) return v;
            if (Array.isArray(v?.data)) return v.data;
          }
          return [];
        };
        return {
          rows: extractRows(raw),
          totalCount:
            raw?.total_count ??
            raw?.data?.total_count ??
            raw?.totalCount ??
            null,
        };
      },
    }),

    runSalesAnalyticsQuery: builder.mutation<
      AnalyticsQueryResponse,
      SalesAnalyticsQueryRequest
    >({
      query(args) {
        const { sellerWorkspaceId, ...body } = args;
        return {
          url: `/hub/reports/api/v1/analytics/sales`,
          method: 'POST',
          params: {
            sellerWorkspaceId,
          },
          body,
        };
      },
      transformResponse(raw: any): AnalyticsQueryResponse {
        const extractRows = (data: any): AnalyticsRow[] => {
          if (Array.isArray(data)) return data;
          for (const key of ['data', 'rows', 'result', 'records']) {
            const v = data?.[key];
            if (Array.isArray(v)) return v;
            if (Array.isArray(v?.data)) return v.data;
          }
          return [];
        };
        return {
          rows: extractRows(raw),
          totalCount:
            raw?.total_count ??
            raw?.data?.total_count ??
            raw?.totalCount ??
            null,
        };
      },
    }),

    getAnalyticsConfig: builder.query<
      GetAnalyticsConfigResponse,
      GetAnalyticsConfigRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v1/analytics/config`,
          method: 'GET',
          params: arg,
        };
      },
    }),

    saveAnalyticsConfig: builder.mutation<
      SaveAnalyticsConfigResponse,
      SaveAnalyticsConfigRequest
    >({
      query(arg) {
        const { sellerWorkspaceId, ...body } = arg;
        return {
          url: `/hub/reports/api/v1/analytics/config`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body,
        };
      },
    }),

    downloadAnalyticsChart: builder.mutation<Blob, AnalyticsDownloadRequest>({
      query(args) {
        const { sellerWorkspaceId, ...body } = args;
        return {
          url: `/hub/reports/api/v1/analytics/download`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body,
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    getProductView: builder.mutation<ProductViewResponse, ProductViewRequest>({
      query(arg) {
        const { sellerWorkspaceId, ...body } = arg;
        return {
          url: '/hub/reports/api/v1/analytics/productview',
          method: 'POST',
          params: { sellerWorkspaceId },
          body,
        };
      },
    }),

    getProductViewFilter: builder.mutation<
      ProductViewFilterResponse,
      ProductViewFilterRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v1/analytics/product/filter',
          method: 'POST',
          params: { sellerWorkspaceId: arg.sellerWorkspaceId },
          body: {},
        };
      },
    }),

    getPaymentViewFilter: builder.mutation<
      PaymentViewFilterResponse,
      PaymentViewFilterRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v1/analytics/customer/filter',
          method: 'POST',
          params: { sellerWorkspaceId: arg.sellerWorkspaceId },
          body: {},
        };
      },
    }),

    getProductDetail: builder.mutation<
      ProductDetailResponse,
      ProductDetailRequest
    >({
      query(arg) {
        const { sellerWorkspaceId, ...body } = arg;
        return {
          url: '/hub/reports/api/v1/analytics/productview/product',
          method: 'POST',
          params: { sellerWorkspaceId },
          body,
        };
      },
    }),

    getAnalyticsMetadata: builder.query<
      AnalyticsMetadataResponse,
      AnalyticsMetadataRequest
    >({
      query(arg) {
        return {
          url: `/hub/reports/api/v1/analytics/views/${arg?.view}/metadata`,
          method: 'GET',
          params: arg?.params,
        };
      },
    }),

    customerPerformanceReport: builder.mutation<
      CustomerPerformanceReportResponse,
      CustomerPerformanceReportRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v1/analytics/customer',
          method: 'POST',
          params: arg?.params,
          body: arg?.body,
        };
      },
    }),
    getCustomerAnalyticsReportFilters: builder.mutation<
      AnalyticsFiltersResponse,
      AnalyticsFiltersRequest
    >({
      query(arg) {
        const { sellerWorkspaceId, filterScreen, ...body } = arg;
        return {
          url: '/hub/reports/api/v1/analytics/customer/filter',
          method: 'POST',
          params: { sellerWorkspaceId },
          body,
        };
      },
      onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        if (request?.filterScreen as SiftScreenEnum) {
          queryFulfilled?.then((response) => {
            cacheReportFilterResponseByScreen(
              dispatch,
              request.filterScreen,
              response?.data
            );
            const appliedFilters = getAppliedFilters(getState() as RootState);
            const stateInputItems = mapStringDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.state || [],
              ''
            );
            const pincodeInputItems =
              mapStringDataToInputItemsFromAppliedFilter(
                appliedFilters,
                response?.data?.pincode || [],
                ''
              );

            dispatch(
              updateSiftByScreen({
                screen: request?.filterScreen as SiftScreenEnum,
                filters: {
                  state: stateInputItems,
                  pincode: pincodeInputItems,
                },
              })
            );
          });
        }
      },
    }),

    performanceReportDownload: builder.mutation<
      any,
      PerformanceReportDownloadRequest
    >({
      query(arg) {
        return {
          url: '/hub/reports/api/v1/analytics/download',
          method: 'POST',
          params: arg?.params,
          body: arg?.body,
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    getSalesTeamMemberReport: builder.mutation<
      SalesTeamMemberReportResponse,
      SalesTeamMemberReportRequest
    >({
      query(arg) {
        const { sellerWorkspaceId, ...body } = arg;
        return {
          url: '/hub/reports/api/v1/analytics/sales_team_member',
          method: 'POST',
          params: { sellerWorkspaceId },
          body,
        };
      },
    }),
    getSalesTeamAnalyticsReportFilters: builder.mutation<
      AnalyticsFiltersResponse,
      AnalyticsFiltersRequest
    >({
      query(arg) {
        const { sellerWorkspaceId, filterScreen, ...body } = arg;
        return {
          url: '/hub/reports/api/v1/analytics/sales_team_member/filter',
          method: 'POST',
          params: { sellerWorkspaceId },
          body,
        };
      },
      onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        if (request?.filterScreen as SiftScreenEnum) {
          queryFulfilled?.then((response) => {
            cacheReportFilterResponseByScreen(
              dispatch,
              request.filterScreen,
              response?.data
            );
            const appliedFilters = getAppliedFilters(getState() as RootState);

            const salesManInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.sales_team_members,
              'salesteammemberid',
              'sales_team_member',
              ''
            )?.filter((x) => x.value);

            dispatch(
              updateSiftByScreen({
                screen: request?.filterScreen as SiftScreenEnum,
                filters: {
                  customers: [],
                  salesmen: salesManInputItems,
                },
              })
            );
          });
        }
      },
    }),
    getOrderAnalyticsReport: builder.mutation<
      OrderReportResponse,
      AnalyticsRequest
    >({
      query(arg) {
        const { sellerWorkspaceId, ...body } = arg;
        return {
          url: '/hub/reports/api/v1/analytics/orders',
          method: 'POST',
          params: { sellerWorkspaceId },
          body,
        };
      },
    }),
    getOrderAnalyticsReportFilters: builder.mutation<
      AnalyticsFiltersResponse,
      AnalyticsFiltersRequest
    >({
      query(arg) {
        const { sellerWorkspaceId, filterScreen, ...body } = arg;
        return {
          url: '/hub/reports/api/v1/analytics/orders/filter',
          method: 'POST',
          params: { sellerWorkspaceId },
          body,
        };
      },
      onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        if (request?.filterScreen as SiftScreenEnum) {
          queryFulfilled?.then((response) => {
            cacheReportFilterResponseByScreen(
              dispatch,
              request.filterScreen,
              response?.data
            );
            const appliedFilters = getAppliedFilters(getState() as RootState);
            const fulfillmentsInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.cfas,
              'id',
              'name',
              ''
            )?.filter((x: any) => x.value);

            const salesManInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              response?.data?.teamMembers,
              'id',
              'name',
              ''
            )?.filter((x) => x.value);
            const statuses = [
              { id: 'AddingItems', name: 'Draft' },
              { id: 'SubmittedByCustomer', name: 'Submitted' },
              { id: 'Approved', name: 'Accepted' },
              { id: 'Cancelled', name: 'Cancelled' },
              { id: 'Billed', name: 'Billed' },
            ];
            const statusInputItems = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              statuses,
              'id',
              'name',
              ''
            );

            dispatch(
              updateSiftByScreen({
                screen: request?.filterScreen as SiftScreenEnum,
                filters: {
                  customers: [],
                  cfa: fulfillmentsInputItems,
                  salesmen: salesManInputItems,
                  statuses: statusInputItems,
                },
              })
            );
          });
        }
      },
    }),
    getPaymentReport: builder.mutation<
      PaymentReportResponse,
      PaymentReportRequest
    >({
      query(arg) {
        const { sellerWorkspaceId, ...body } = arg;
        return {
          url: '/hub/reports/api/v1/analytics/paymentview/transactions',
          method: 'POST',
          params: { sellerWorkspaceId },
          body,
        };
      },
    }),
  }),
});

export const {
  usePerformanceReportDownloadMutation,
  useCustomerPerformanceReportMutation,
  useGenerateOtifAbsoluteOrdersReportMutation,
  useGenerateOtifRecivedOrdersReportMutation,
  useGenerateOtifOrderFulfilmentReportMutation,
  useSalesLeaderBoardMutation,
  useRevenueReportMutation,
  useReceivedOrdersReportMutation,
  useDailyOrdersReportMutation,
  useDailyPaymentsReportMutation,
  useDailyInvoicesReportMutation,
  useTopCustomersByOrderValueMutation,
  useBottomCustomersByOrderValueMutation,
  useTopProductsByQuantitySoldMutation,
  useBottomProductsByQuantitySoldMutation,
  useLazyRecentOrdersReportQuery,
  useLazyRecentInvoiceReportQuery,
  useLazyRecentPaymentReportQuery,
  useZoaiReportMutation,
  useCustomerCfaReportMutation,
  useDownloadCfaReportsMutation,
  useLedgerSummaryReportMutation,
  useOrderSummaryReportDownloadMutation,
  useOrderDetailsReportMutation,
  useSalesLeaderboardReportMutation,
  useSalesLeaderboardReportDownloadMutation,
  useCustomerPerformanceReportDownloadMutation,
  useProductPerformanceReportDownloadMutation,
  useInvoiceReportMutation,
  useProductPerformanceReportFilterMutation,
  useSalesTeamCheckinReportMutation,
  useGetPaymentReportApiMutation,
  useGetSecondaryInvoiceReportApiMutation,
  useSecondaryInvoiceReportDownloadMutation,
  useSecondaryInvoiceReportFilterMutation,
  useCustomerPerformanceReportFilterMutation,
  useSalesTeamCheckinReportFilterMutation,
  useInvoiceReportFilterMutation,
  useRecentPaymentsReportFilterMutation,
  useSupplyTrackerReportFilterMutation,
  useOrderDetailsReportFilterMutation,
  usePaymentsReportDownloadMutation,
  useInvoicesReportDownloadMutation,
  useSalesTeamCheckinDownloadMutation,
  useSupplyTrackerReportDownloadMutation,
  useBusinessSummaryReportMutation,
  useLazyGetKpiListQuery,
  useModifyKpisMutation,
  useGetKpiDetailsMutation,
  useGetSegmentAnalysisMutation,
  useUpdateDashboardFiltersMutation,
  useListDashboardFiltersMutation,
  useLazyGetAppliedDashboardFiltersQuery,
  useCfaCustomerWiseProductReportMutation,
  useCfaCustomerWiseProductReportFilterMutation,
  useCampaignCustomersReportMutation,
  useDownloadSalesmenReportMutation,
  useListDynamicSegmentsMutation,
  useGetDynamicSegmentsDetailsMutation,
  useDownloadDynamicSegmentsDetailsMutation,
  useGetWeeklySalesReportMutation,
  useGetMonthlySalesReportMutation,
  useSalesManReportMutation,
  useLedgerCustomerMutation,
  useSalesLeaderClockinsReportMutation,
  useSalesLeaderClockinDownloadMutation,
  useRunAnalyticsQueryMutation,
  useRunSalesAnalyticsQueryMutation,
  useLazyGetAnalyticsConfigQuery,
  useGetAnalyticsConfigQuery,
  useSaveAnalyticsConfigMutation,
  useDownloadAnalyticsChartMutation,
  useDashboardPaymentsReportMutation,
  useGetProductViewMutation,
  useGetProductViewFilterMutation,
  useGetPaymentViewFilterMutation,
  useGetProductDetailMutation,
  useDashboardCustomerPaymentsReportMutation,
  useDashboardPaymentInvoiceMutation,
  useGetAnalyticsMetadataQuery,
  useLazyGetAnalyticsMetadataQuery,
  useGetSalesTeamMemberReportMutation,
  useGetOrderAnalyticsReportMutation,
  useGetOrderAnalyticsReportFiltersMutation,
  useGetCustomerAnalyticsReportFiltersMutation,
  useGetSalesTeamAnalyticsReportFiltersMutation,
  useGetPaymentReportMutation,
} = reportsApi;
